export default function createTitlePage(title) {
	const titlePage = title
		.split(' ')
		.map((palavra) => palavra && palavra[0].toUpperCase())
		.join('');

	return titlePage;
}
